var $bb4efe76ac2ad6af$exports = {};
$bb4efe76ac2ad6af$exports = {
    "collectionLabel": `F\xf6rslag`
};


export {$bb4efe76ac2ad6af$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
